import React, { useState, useEffect } from "react";
import { RiExternalLinkLine } from "react-icons/ri";

function ProjectCard({ title, description, images, technologies, link }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    if (images.length > 1) {
      const interval = setInterval(nextImage, 3000);
      return () => clearInterval(interval);
    }
  }, [images]);

  return (
    <div className="flex flex-col sm:flex-row mb-12 mx-4 mr-20  rounded-lg shadow-lg overflow-hidden">
      <div
        className="relative w-full sm:w-1/2"
        data-aos="zoom-in"
        data-aos-duration="2000"
        data-aos-easing="ease-in-out"
      >
        {images.length > 1 ? (
          <div className="relative">
            <div className="overflow-hidden rounded-lg">
              <div
                className="flex transition-transform duration-500"
                style={{
                  transform: `translateX(-${currentImageIndex * 100}%)`,
                }}
              >
                {images.map((imageUrl, index) => (
                  <img
                    key={index}
                    src={imageUrl}
                    alt={`${title}-${index}`}
                    className="w-full h-full object-cover"
                  />
                ))}
              </div>
            </div>
            <button
              className="absolute top-1/2 left-2 sm:left-4 transform -translate-y-1/2 bg-white bg-opacity-70 px-3 sm:px-4 py-1 sm:py-2 rounded-full text-gray-800 shadow-md hover:bg-opacity-90 transition"
              onClick={prevImage}
            >
              &larr;
            </button>
            <button
              className="absolute top-1/2 right-2 sm:right-4 transform -translate-y-1/2 bg-white bg-opacity-70 px-3 sm:px-4 py-1 sm:py-2 rounded-full text-gray-800 shadow-md hover:bg-opacity-90 transition"
              onClick={nextImage}
            >
              &rarr;
            </button>
          </div>
        ) : (
          <img
            src={images[0]}
            alt={title}
            className="w-full h-full object-cover rounded-lg"
          />
        )}
      </div>
      <div
        className="w-full sm:w-1/2 p-4 sm:p-6 flex flex-col justify-center space-y-4"
        data-aos="zoom-in"
        data-aos-duration="2000"
        data-aos-easing="ease-in-out"
      >
        <h2 className="text-xl sm:text-2xl font-bold text-white mb-2">
          {title}
        </h2>
        <p className="text-base sm:text-lg text-gray-300 mb-4">{description}</p>
        <div className="flex flex-wrap gap-2 mt-2">
          {technologies.map((tech, index) => (
            <span
              key={index}
              className="px-2 sm:px-3 py-1 sm:py-2 border-blue-400 border-2 text-white bg-blue-700 rounded-full text-xs sm:text-sm font-medium"
            >
              {tech}
            </span>
          ))}
        </div>
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300 flex items-center mt-2 sm:mt-4 transition duration-300 ease-in-out"
        >
          View Project <RiExternalLinkLine className="ml-1" />
        </a>
      </div>
    </div>
  );
}

export default ProjectCard;
